// @flow
import clientsReducer from './clientsReducer';
import {
  userProfilesReducer,
  expertUserProfilesReducer,
} from './userProfilesReducer';
import clientModerationAlertConfig from './alertConfigReducer';
import clientProperties from './clientPropertiesReducer';
import clientCatalogs from './catalogReducer';

export * from './catalogReducer';

const reducers = {
  clients: clientsReducer,
  clientUserProfiles: userProfilesReducer,
  clientExpertUserProfiles: expertUserProfilesReducer,
  clientModerationAlertConfig,
  clientProperties,
  clientCatalogs,
};

export default reducers;



// WEBPACK FOOTER //
// ./src/containers/client/reducer.js